import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth/auth.service';
import { LoginService } from 'src/app/services/login.service';
import { UsuarioService } from 'src/app/services/usuario.service';

@Component({
    selector: 'app-outros',
    templateUrl: './outros.component.html'
})
export class OutrosComponent implements OnInit {

    modalRef: NgbModalRef;

    public login = '';
    public senha = '';
    public logando = false;
    public loginNaoValido = false;
    public isMaster = false;
    public perfil = '';
    public outro = '';

    constructor(private appService: AppService,
        private router: Router,
        private authService: AuthService,
        private loginService: LoginService,
        private spinner: NgxSpinnerService,
        private usuarioService: UsuarioService) {

        this.appService.pageTitle = 'Login';
    }

    logar() {
        this.loginNaoValido = false;
        this.logando = true;

        //this.router.navigateByUrl('/home');
        this.authService.loginother(this.login, this.senha, this.outro)
            .subscribe(res => {
                // var login = res.data;

                // //window.localStorage.setItem('role', tokenLogin.Role);
                // window.localStorage.setItem('iso.access_token', login.token);
                // window.localStorage.setItem('iso.usuario', login.email);

                this.isMaster = this.authService.isMaster();
                this.perfil = this.authService.getPerfil();
                let ambientes = this.authService.getUserAmbientes();
                this.appService.pageTitle = 'Serviços Empresarias';

                console.log(this.perfil);
                if (ambientes.length > 1) {
                    this.authService.setAmbiente('');
                    this.router.navigateByUrl('/home/ambiente');
                } else {
                    this.authService.setAmbiente(ambientes[0]);
                    if (this.isMaster === true || this.perfil == 'Financeiro') {
                        this.router.navigateByUrl('/home/administrativo');
                    } else {
                        console.log(this.perfil);
                        if (this.perfil == 'Advogado' || this.perfil == 'Revisor') {
                            this.router.navigateByUrl('/dashboard/area-trabalho');
                        } else {
                            this.router.navigateByUrl('/operacionais/operacao-de-processos');
                        }
                    }
                }
            }, error => {
                this.logando = false;
                this.loginNaoValido = true;

                // this.router.navigateByUrl('/home');
            });
    }

    esqueceuSenha() {
        this.router.navigateByUrl('/esqueceu-senha');
    }

    ngOnInit(): void {
        if (this.modalRef) {
            this.modalRef.close();
        }
        this.spinner.hide();
    }
}

